import Vue from 'vue'
import VueRouter from 'vue-router'
import Router from 'vue-router'


Vue.use(Router)

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}



export default new Router({
  // mode: 'history',

  routes: [
    {
      path: '/',
      name: 'Home',
      component: (resolve) => require(['../views/index.vue'], resolve)
    },
    {
      path: '/core-tech/automl',
      name: 'TechnicalAdvantages',
      component: (resolve) => require(['../views/technicalAdvantages/index.vue'], resolve),
      children: [
        {
          path: '/core-tech/automl',
          name: 'TechTab1',
          component: (resolve) => require(['../views/technicalAdvantages/components/Tab1.vue'], resolve),
        },
        {
          path: '/core-tech/confidence-ai',
          name: 'TechTab2',
          component: (resolve) => require(['../views/technicalAdvantages/components/Tab2.vue'], resolve),
        },
        {
          path: '/core-tech/active-learning',
          name: 'TechTab3',
          component: (resolve) => require(['../views/technicalAdvantages/components/Tab3.vue'], resolve),
        },
        {
          path: '/core-tech/few-shot-learning',
          name: 'TechTab4',
          component: (resolve) => require(['../views/technicalAdvantages/components/Tab4.vue'], resolve),
        },
        {
          path: '/core-tech/federated-learning',
          name: 'TechTab5',
          component: (resolve) => require(['../views/technicalAdvantages/components/Tab5.vue'], resolve),
        }
      ]
    },
    {
      path: '/industry-applications/semiconductor-wafers',
      name: 'IndustryApplication',
      component: (resolve) => require(['../views/industryApplication/index.vue'], resolve),
      children: [
        {
          path: '/industry-applications/semiconductor-wafers',
          name: 'AppTab1',
          component: (resolve) => require(['../views/industryApplication/components/Tab1.vue'], resolve),
        },
        {
          path: '/industry-applications/electronic-components',
          name: 'AppTab2',
          component: (resolve) => require(['../views/industryApplication/components/Tab2.vue'], resolve),
        },
        {
          path: '/industry-applications/new-energy-battery',
          name: 'AppTab3',
          component: (resolve) => require(['../views/industryApplication/components/Tab3.vue'], resolve),
        },
        {
          path: '/industry-applications/solar-photovoltaics',
          name: 'AppTab4',
          component: (resolve) => require(['../views/industryApplication/components/Tab4.vue'], resolve),
        },
        {
          path: '/industry-applications/3c',
          name: 'AppTab5',
          component: (resolve) => require(['../views/industryApplication/components/Tab5.vue'], resolve),
        },
        {
          path: '/industry-applications/automobile-manufacturing',
          name: 'AppTab6',
          component: (resolve) => require(['../views/industryApplication/components/Tab6.vue'], resolve),
        },
        {
          path: '/industry-applications/textile-industry',
          name: 'AppTab7',
          component: (resolve) => require(['../views/industryApplication/components/Tab7.vue'], resolve),
        },
        {
          path: '/industry-applications/bacterial-detection',
          name: 'AppTab8',
          component: (resolve) => require(['../views/industryApplication/components/Tab8.vue'], resolve),
        }
      ]
    },
    {
      path: '/industry-modual/ai-camera',
      name: 'ProdTab1',
      component: (resolve) => require(['../views/productCenter/industryModual/index.vue'], resolve),
      children: [
        {
          path: '/industry-modual/ai-camera',
          name: 'IndustryTab1',
          component: (resolve) => require(['../views/productCenter/industryModual/components/Tab1.vue'], resolve),
        },
        {
          path: '/industry-modual/ai-lightsource',
          name: 'IndustryTab2',
          component: (resolve) => require(['../views/productCenter/industryModual/components/Tab2.vue'], resolve),
        },
        {
          path: '/industry-modual/ai-box',
          name: 'IndustryTab3',
          component: (resolve) => require(['../views/productCenter/industryModual/components/Tab3.vue'], resolve),
        },
        {
          path: '/industry-modual/binocular-3d-camera',
          name: 'IndustryTab4',
          component: (resolve) => require(['../views/productCenter/industryModual/components/Tab4.vue'], resolve),
        }
      ]
    },
    {
      path: '/ai-platform/vision-ap-platform',
      name: 'VisualApplication',
      component: (resolve) => require(['../views/productCenter/aiPlatform/visualApplication/index.vue'], resolve),
    },
    {
      path: '/ai-platform/algo-gen-platform',
      name: 'AlgorithmGeneration',
      component: (resolve) => require(['../views/productCenter/aiPlatform/algorithmGeneration/index.vue'], resolve),
    },
    {
      path: '/industry-inspection/2d-aoi',
      name: 'ProdTab3',
      component: (resolve) => require(['../views/productCenter/industryInspection/index.vue'], resolve),
      children: [
        {
          path: '/industry-inspection/2d-aoi',
          name: 'InspectionTab1',
          component: (resolve) => require(['../views/productCenter/industryInspection/components/Tab1.vue'], resolve),
        },
        {
          path: '/industry-inspection/3d-aoi',
          name: 'InspectionTab2',
          component: (resolve) => require(['../views/productCenter/industryInspection/components/Tab2.vue'], resolve),
        },
        {
          path: '/industry-inspection/3d-spi',
          name: 'InspectionTab3',
          component: (resolve) => require(['../views/productCenter/industryInspection/components/Tab3.vue'], resolve),
        },
        {
          path: '/industry-inspection/dip-aoi',
          name: 'InspectionTab4',
          component: (resolve) => require(['../views/productCenter/industryInspection/components/Tab4.vue'], resolve),
        }
      ]
    },
    {
      path: '/aboutus',
      name: 'AboutSailyond',
      component: (resolve) => require(['../views/aboutSailyond/index.vue'], resolve),
    },
    {
      path: '/news',
      name: 'News',
      component: (resolve) => require(['../views/aboutSailyond/news/index.vue'], resolve),
    },
    {
      path: '/news/details/:id',
      name: 'Detail',
      component: (resolve) => require(['../views/aboutSailyond/news/components/Detail.vue'], resolve),
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js